<template>
  <j-modal
    :maskClosable="true"
    :width="drawerWidth"
    placement="right"
    :title="title"
    :closable="true"
    @close="handleCancel"
    @cancel="handleCancel"
    :visible="visible"
    :footer="null"
    :fullscreen.sync="modal.fullscreen" 
    cancelText="确定"
    >
    <div style="display:flex;padding:0 0 0 10%">
       <a-form-model-item  :label-col="labelCol" :wrapper-col="wrapperCol" label="委派人" style="width:100%">
        <a-select v-model="wprValue">
            <a-select-option value="">--请选择--</a-select-option>
            <a-select-option v-for="(item, key) in okFlowUserList" :key="key" :value="item.userCode">{{item.userName}}</a-select-option>
        </a-select>
       </a-form-model-item>
    </div>

    <div style="text-align: center; margin-top: 20px">
      <a-button
        v-if="buttonStatu"
        @click="handleOk"
        type="primary"
        slot="extra"
        style="width: 100px; height: 30px">提交</a-button>
      </div>
    </j-modal>
  
</template>


<script>
import '@/assets/less/TableExpand.less'
import { httpAction } from '@/api/manage'

export default {
  name: 'LcsjgWp',
  components: {
    },
  data() {
    return {
      title: '选择委派人',
      visible: false,
      modal: {
        fullscreen: false,
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      wprValue:"",
      flowId:"",
      drawerWidth:1000,
      indexStyle: 1,
      okFlowUserList: [],
      comments: '',
      buttonStatu: true,
      processType: '1',
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      url: {
        toDelegate: '/okflow/flow-data/list/delegate-user',
        doDelegate: '/okflow/flow-data/delegate'
      },
    }
  },
  methods: {
    toWp(record)  {
      this.wprValue="";
      this.okFlowUserList=[];
      this.visible = true;
      this.flowId=record.id;
      httpAction(this.url.toDelegate+"?flowId="+record.id,null,'get').then((res)=>{
        this.okFlowUserList = res;
      })
    },
    close () {
      this.visible = false;
      this.$emit('close');
    },
    handleCancel () {
      this.close()
    },
    handleOk(){
      if(this.wprValue==''){
        this.$message.warning("请选择委派对象！");
        return;
      }
      httpAction(this.url.doDelegate+"?flowId="+this.flowId+"&userCode="+this.wprValue,null,'post').then((res)=>{
      this.$message.warning(res.message);
        this.close();
        //更新代办list
        this.$emit('updataList')
      })
    }

  }
}

</script>

<style>
  .hszt{
    color:#b5b0b0;
  }
</style>